package dev.lingvo.ops.state

import dev.lingvo.shared.ops.OpsPage
import dev.lingvo.site.ds.LPageState

/** A cursor stack for older/newer navigation without computing an offset. */
class KeysetWindow<T>(val pageSize: Int) {
    private var stack = listOf<String?>(null)
    private var shown = 0
    private var nextCursor: String? = null
    private var fromDeepLink = false

    val state: LPageState
        get() = LPageState(
            shown = shown,
            pageSize = if (nextCursor != null) shown else 0,
            hasOlder = nextCursor != null,
            hasNewer = stack.size > 1 || fromDeepLink,
            pageNumber = stack.size + if (fromDeepLink) 1 else 0,
            newerIsJumpToNewest = fromDeepLink && stack.size == 1,
        )

    fun accept(page: OpsPage<T>) {
        shown = page.rows.size
        nextCursor = page.nextCursor
    }

    fun older(): String? = nextCursor?.also { stack = stack + it }

    fun newer(): String? = if (fromDeepLink && stack.size == 1) {
        fromDeepLink = false
        null
    } else {
        stack = stack.dropLast(1)
        stack.last()
    }

    fun reset() {
        stack = listOf(null)
        fromDeepLink = false
        shown = 0
        nextCursor = null
    }

    fun seedFromDeepLink(cursor: String) {
        stack = listOf(cursor)
        fromDeepLink = true
    }
}
